import React from "react";
import { fileUrl } from "../lib/api";
import { UploadButton } from "./AuthImg";
import { X } from "lucide-react";

const isImg = (a) => (a.content_type || "").startsWith("image/") || /\.(jpg|jpeg|png|gif|webp|heic)$/i.test(a.name || "");
const isVideo = (a) => (a.content_type || "").startsWith("video/") || /\.(mp4|mov|avi|webm|mkv)$/i.test(a.name || "");

/** Listă read-only de atașamente task (poze/video/fișiere) cu link de deschidere. */
export function TaskAttachmentList({ attachments, testPrefix = "task-att" }) {
  if (!attachments || attachments.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      {attachments.map((a) => (
        <a
          key={a.file_id}
          href={fileUrl(a.file_id)}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1 text-[11px] bg-white border border-zinc-200 rounded p-1 hover:border-blue-400"
          data-testid={`${testPrefix}-${a.file_id}`}
        >
          {isImg(a) ? (
            <img src={fileUrl(a.file_id)} alt={a.name} className="w-10 h-10 object-cover rounded"/>
          ) : isVideo(a) ? (
            <span className="w-10 h-10 grid place-items-center bg-zinc-900 rounded text-white text-base">🎬</span>
          ) : (
            <span className="w-10 h-10 grid place-items-center bg-zinc-100 rounded text-zinc-500">📎</span>
          )}
          <span className="text-zinc-700 max-w-[120px] truncate">{a.name}</span>
        </a>
      ))}
    </div>
  );
}

/** Picker de atașamente (upload + preview + remove) — pentru creare/executare task. */
export function TaskAttachmentPicker({ attachments, setAttachments, testId = "task-upload", label = "📷 Adaugă poză / video", accept = "image/*,video/*,application/pdf" }) {
  const onUploaded = (data) => {
    if (!data?.id) return;
    setAttachments((arr) => [...arr, {
      file_id: data.id,
      name: data.original_filename || data.filename || data.name || "fișier",
      content_type: data.content_type,
    }]);
  };
  const remove = (fid) => setAttachments((arr) => arr.filter((x) => x.file_id !== fid));
  return (
    <div className="flex flex-wrap items-center gap-2">
      {(attachments || []).map((a) => (
        <div key={a.file_id} className="relative group" data-testid={`task-attachment-pending-${a.file_id}`}>
          {isImg(a) ? (
            <img src={fileUrl(a.file_id)} alt={a.name} className="w-16 h-16 object-cover rounded border border-zinc-200"/>
          ) : isVideo(a) ? (
            <div className="w-16 h-16 grid place-items-center bg-zinc-900 rounded border border-zinc-200 text-white text-lg" title={a.name}>🎬</div>
          ) : (
            <div className="w-16 h-16 grid place-items-center bg-zinc-100 rounded border border-zinc-200 text-zinc-500 text-xs" title={a.name}>📎</div>
          )}
          <button
            type="button"
            onClick={() => remove(a.file_id)}
            className="absolute -top-1.5 -right-1.5 bg-red-500 text-white rounded-full p-0.5 hover:bg-red-600"
            data-testid={`task-attachment-remove-${a.file_id}`}
          >
            <X size={10}/>
          </button>
        </div>
      ))}
      <UploadButton testId={testId} label={label} accept={accept} onUploaded={onUploaded} />
    </div>
  );
}
